export default "__VITE_ASSET__DcSqeXUr__"